var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle29, _circle30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5156,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.009 100.308 167.009C63.1536 167.009 33.0493 137.155 33.0493 100.347C33.0493 63.539 63.1536 33.6853 100.308 33.6853C137.462 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.61489,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7996,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51221 117.65C7.5667 117.65 8.42153 116.795 8.42153 115.741C8.42153 114.686 7.5667 113.831 6.51221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5317 22.4228C75.5862 22.4228 76.4411 21.5679 76.4411 20.5134C76.4411 19.459 75.5862 18.6041 74.5317 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5948 118.924 17.6493C118.924 18.7038 119.779 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.718 39.6063M151.024 30.0597L149.472 30.0597M162.599 20.7518L162.599 8.57985M167.134 30.0597C164.15 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.021 30.0597 162.48 28.5084 162.718 25.4057C162.718 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.635 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.8154,
    y: 42.0867,
    width: 113.685,
    height: 31.1629,
    rx: 5,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0771,
    y: 82.1906,
    width: 113.685,
    height: 31.1629,
    rx: 5,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0444,
    y: 123.837,
    width: 113.685,
    height: 31.1629,
    rx: 5,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3638 52.6552H101.658",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.626 92.759H83.9197",
    stroke: "#194590",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7926 107.585C41.3098 107.585 38.9766 106.618 37.2207 104.865C35.4648 103.111 34.5 100.775 34.5 98.2926C34.5 95.8098 35.4675 93.4766 37.2207 91.7207C38.9739 89.9648 41.3098 89 43.7926 89C46.2755 89 48.6086 89.9675 50.3645 91.7207C52.1204 93.4739 53.0852 95.8098 53.0852 98.2926C53.0852 100.775 52.1177 103.109 50.3645 104.865C48.6113 106.62 46.2755 107.585 43.7926 107.585ZM43.7926 89.1069C41.3392 89.1069 39.0327 90.0637 37.2982 91.7982C35.5637 93.5327 34.6069 95.8392 34.6069 98.2926C34.6069 100.746 35.5637 103.053 37.2982 104.787C39.0327 106.522 41.3392 107.478 43.7926 107.478C46.2461 107.478 48.5525 106.522 50.287 104.787C52.0215 103.053 52.9783 100.746 52.9783 98.2926C52.9783 95.8392 52.0215 93.5327 50.287 91.7982C48.5525 90.0637 46.2461 89.1069 43.7926 89.1069Z",
    fill: "#194590"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7928 105.14C41.9647 105.14 40.2462 104.429 38.9527 103.135C37.6592 101.842 36.9482 100.123 36.9482 98.2952C36.9482 96.4671 37.6592 94.7487 38.9527 93.4551C40.2462 92.1616 41.9647 91.4507 43.7928 91.4507C45.6208 91.4507 47.3393 92.1616 48.6328 93.4551C49.9264 94.7487 50.6373 96.4671 50.6373 98.2952C50.6373 100.123 49.9264 101.842 48.6328 103.135C47.3393 104.429 45.6208 105.14 43.7928 105.14ZM43.7928 91.5522C41.9914 91.5522 40.2997 92.2525 39.0275 93.5273C37.7554 94.7994 37.0525 96.4912 37.0525 98.2925C37.0525 100.094 37.7527 101.786 39.0275 103.058C40.2997 104.33 41.9914 105.033 43.7928 105.033C45.5941 105.033 47.2858 104.333 48.558 103.058C49.8301 101.786 50.533 100.094 50.533 98.2925C50.533 96.4912 49.8328 94.7994 48.558 93.5273C47.2858 92.2551 45.5941 91.5522 43.7928 91.5522Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7921 100.947C42.3275 100.947 41.1382 99.7574 41.1382 98.2928C41.1382 96.8282 42.3275 95.6389 43.7921 95.6389C45.2567 95.6389 46.446 96.8282 46.446 98.2928C46.446 99.7574 45.2567 100.947 43.7921 100.947ZM43.7921 95.7458C42.389 95.7458 41.2451 96.8897 41.2451 98.2928C41.2451 99.6959 42.389 100.84 43.7921 100.84C45.1952 100.84 46.3391 99.6959 46.3391 98.2928C46.3391 96.8897 45.1952 95.7458 43.7921 95.7458Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.898 99.9577C50.2862 99.9577 52.2222 98.0217 52.2222 95.6335C52.2222 93.2452 50.2862 91.3092 47.898 91.3092C45.5098 91.3092 43.5737 93.2452 43.5737 95.6335C43.5737 98.0217 45.5098 99.9577 47.898 99.9577Z",
    fill: "#194590"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7926 107.585C41.3098 107.585 38.9766 106.618 37.2207 104.865C35.4648 103.111 34.5 100.775 34.5 98.2926C34.5 95.8098 35.4675 93.4766 37.2207 91.7207C38.9739 89.9648 41.3098 89 43.7926 89C46.2755 89 48.6086 89.9675 50.3645 91.7207C52.1204 93.4739 53.0852 95.8098 53.0852 98.2926C53.0852 100.775 52.1177 103.109 50.3645 104.865C48.6113 106.62 46.2755 107.585 43.7926 107.585ZM43.7926 89.1069C41.3392 89.1069 39.0327 90.0637 37.2982 91.7982C35.5637 93.5327 34.6069 95.8392 34.6069 98.2926C34.6069 100.746 35.5637 103.053 37.2982 104.787C39.0327 106.522 41.3392 107.478 43.7926 107.478C46.2461 107.478 48.5525 106.522 50.287 104.787C52.0215 103.053 52.9783 100.746 52.9783 98.2926C52.9783 95.8392 52.0215 93.5327 50.287 91.7982C48.5525 90.0637 46.2461 89.1069 43.7926 89.1069Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.1917 98.8325C35.6358 98.8325 35.0986 98.9074 34.5854 99.0463C34.6282 99.5621 34.7111 100.065 34.834 100.554C35.2616 100.42 35.7186 100.348 36.1917 100.348C38.7093 100.348 40.7511 102.39 40.7511 104.907C40.7511 105.602 40.5961 106.262 40.3155 106.853C40.7832 107.043 41.2723 107.198 41.7747 107.31C42.0928 106.572 42.2692 105.763 42.2692 104.91C42.2665 101.553 39.5458 98.8325 36.1917 98.8325Z",
    fill: "#194590"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5627 92.0041C49.9186 91.3119 49.1729 90.7186 48.3444 90.2509C48.8522 90.7694 49.1676 91.4776 49.1676 92.2607C49.1676 93.8456 47.8847 95.1284 46.2999 95.1284C44.715 95.1284 43.4322 93.8456 43.4322 92.2607C43.4322 90.6812 44.707 89.401 46.2838 89.393C45.4927 89.1712 44.6562 89.0536 43.7957 89.0536C43.6887 89.0536 43.5818 89.0563 43.4749 89.0589C42.5903 89.842 42.0317 90.9859 42.0317 92.2607C42.0317 94.6206 43.9426 96.5315 46.3025 96.5315C48.6624 96.5315 50.5734 94.6206 50.5734 92.2607C50.5707 92.1752 50.5653 92.0897 50.5627 92.0041Z",
    fill: "#194590"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5928 134.406H100.887",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7495 62.681H130.193",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0117 102.785H112.455",
    stroke: "#194590",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.978 144.432H129.422",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.7826,
    cy: 58.0537,
    r: 8.25477,
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0116,
    cy: 139.804,
    r: 8.25477,
    stroke: "#787E8C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.b15cdb696ba867792e0eb8a72135a316.svg";
export { ForwardRef as ReactComponent };